import React from 'react';

import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import { Stack } from '@mui/material';

import Tabs from '../../components/Tabs';
import useTab from '../../utils/react/hooks/useTab';

import InvoicesTab from './InvoicesTab';
import RefundsTab from './RefundsTab';

const TAB_OPTIONS = [
  {
    key: 'invoices',
    label: 'Invoices',
    icon: <AttachMoneyIcon />,
  },
  {
    key: 'refunds',
    label: 'Refunds',
    icon: <CurrencyExchangeIcon />,
  },
];

const AdminInvoicesPage = () => {
  const [tab, setTab] = useTab({ default: TAB_OPTIONS[0].key });

  return (
    <Stack direction="column">
      <Tabs
        options={TAB_OPTIONS}
        selectedKey={tab}
        onChange={setTab}
      />
      {tab === 'invoices' && (
        <InvoicesTab />
      )}
      {tab === 'refunds' && (
        <RefundsTab />
      )}
    </Stack>
  );
};
export default AdminInvoicesPage;
